import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=70c3d978&"
import script from "./AppImage.js?vue&type=script&lang=js&"
export * from "./AppImage.js?vue&type=script&lang=js&"
import style0 from "./AppImage.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports